import { isObject } from "@gameApp/utils/object";
import type { ForwardedRef, MutableRefObject, RefObject } from "react";

export type RefObjectAny<T> = MutableRefObject<T> | RefObject<T>;

/**
 * Returns HTMLElement or null from unknown input param
 * */
export function refGetElement<T extends HTMLElement>(
  ref: undefined | null | RefObjectAny<T> | ForwardedRef<T>,
): null | T {
  return isObject(ref) && "current" in ref && ref.current instanceof HTMLElement
    ? ref.current
    : null;
}
